/* tslint:disable */
/* eslint-disable */
/**
 * Your Project API
 * Your project description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProjectLocation,
    ProjectLocationFromJSON,
    ProjectLocationFromJSONTyped,
    ProjectLocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedProjectLocationList
 */
export interface PaginatedProjectLocationList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedProjectLocationList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedProjectLocationList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedProjectLocationList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ProjectLocation>}
     * @memberof PaginatedProjectLocationList
     */
    results?: Array<ProjectLocation>;
}

export function PaginatedProjectLocationListFromJSON(json: any): PaginatedProjectLocationList {
    return PaginatedProjectLocationListFromJSONTyped(json, false);
}

export function PaginatedProjectLocationListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedProjectLocationList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ProjectLocationFromJSON)),
    };
}

export function PaginatedProjectLocationListToJSON(value?: PaginatedProjectLocationList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ProjectLocationToJSON)),
    };
}

